export default function SVG_Animation() {
  return (
    <div>
      <h1>SVG_Animation Component</h1>
    </div>
  );
}
